import { useEffect, useState } from "react";
import { getAppInfo, getGrpcClient, getUuidv4 } from "../config/Common.tsx";
import { ZiFetchRequest } from "../protobuf/generated/ZiFetchService_grpc_web_pb";
import GlobalMsgCons from "../config/GlobalMsgCons.tsx";

function Demo(props) {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [userId, setUserId] = useState("");
  const [errors, setErrors] = useState({});
  const [loginButtonLoader, setLoginButtonLoader] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  useEffect(() => {
    let userId = sessionStorage.getItem("loggedInUserId");
    setUserId(userId || "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateForm = () => {
    const tempErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) tempErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      tempErrors.email = "Enter a valid email address";

    if (!formData.password) tempErrors.password = "Password is required";
    else if (formData.password.length < 6)
      tempErrors.password = "Password must be at least 6 characters";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoginButtonLoader(true);
      let { email, password } = formData;
      let deviceInfo = getAppInfo();
      let orgId = "6789acbfaba6474bb7ece202bdc1700e";
      let postJson = {
        reqId: getUuidv4(),
        email: email.toLowerCase(),
        password,
        deviceInfo,
        orgId,
        sessionType: "externalProject",
      };

      const request = new ZiFetchRequest();
      request.setDomain("manage");
      request.setEvent("userSignInBasedOnOrg");
      request.setMessage(JSON.stringify(postJson));
      request.setDatetime(new Date().toString());
      getGrpcClient().sayZiFetch(request, {}, async (err, response) => {
        if (
          response === null ||
          response.getMessage() === GlobalMsgCons.invalidRequest
        ) {
          console.warn("Invalid Request. Please try again later");
        } else {
          let responseData = JSON.parse(response.getMessage());
          response = responseData.response;
          if (response === GlobalMsgCons.success) {
            let { id } = responseData;
            setUserId(id);
            sessionStorage.setItem("loggedInUserId", id);
            window.scrollTo({ top: 0, behavior: "smooth" });
          } else if (response === GlobalMsgCons.passwordMismatch) {
            alert("Password does not match");
          } else if (response === GlobalMsgCons.notExist) {
            alert("Email does not exist");
          } else if (response === GlobalMsgCons.inActiveAccount) {
            alert("Account has been deactivated, please contact admin.");
          }
          setLoginButtonLoader(false);
        }
      });
    }
  };


  return (
    <div className="login-container">
      {userId ? (
        <div style={{ paddingTop: 72}}>
          <video width="100%" controls={true} style={{ height: "calc(100vh - 100px)"}}>
            <source src="https://tv.teqbahn.com/teqitTv-api/files?processType=video&fileName=81148850-0cbc-4fff-8c53-214a4e7f3cb3.mp4" type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
        </div>
      ) : (
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                placeholder="Email"
              />
              {errors.email && (
                <div className="invalid-feedback">{errors.email}</div>
              )}
            </div>
            <div className="mb-3">
              <label>Password</label>
              <div className="input-group">
                <input
                  type={passwordVisible ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  placeholder="Password"
                />
                <div
                  className="input-group-append"
                  onClick={() => {
                    setPasswordVisible((prev) => !prev);
                  }}
                >
                  <span className="input-group-text border-0 cursor-pointer">
                    <i
                      className={`fa ${
                        passwordVisible ? "fa-eye-slash" : "fa-eye"
                      }`}
                    />
                  </span>
                </div>
                {errors.password && (
                  <div className="invalid-feedback">{errors.password}</div>
                )}
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loginButtonLoader}
            >
              Login
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default Demo;
